import styled from 'styled-components'

import { CardPost } from '../cardPost'

export const StyledCardPost = styled(CardPost)`
  .tag-link-item {
    text-decoration: none;
  }
`
